var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDroneRedMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "white",
    stroke: "#F02E25",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5834 23.4549C12.3978 23.6308 12.2495 23.8422 12.1472 24.0765C12.0449 24.3109 11.9907 24.5634 11.9879 24.8191L11.9879 30.982C11.9851 31.0825 12.0104 31.1817 12.061 31.2686C12.1116 31.3554 12.1853 31.4264 12.2741 31.4737C12.3074 31.4857 12.3431 31.4898 12.3783 31.4858C12.4136 31.4818 12.4474 31.4698 12.4772 31.4506L23.9883 23.6857L18.6448 20.018C18.5916 19.8995 18.5544 19.7745 18.534 19.6463C18.622 19.4818 18.7272 19.3271 18.8479 19.1847L12.5834 23.4503",
    fill: "#F02E25",
    fillOpacity: 0.38
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3925 23.4345C35.5781 23.6109 35.7265 23.8227 35.8288 24.0574C35.9311 24.2921 35.9852 24.545 35.988 24.801L35.988 30.9639C35.9912 31.0642 35.9664 31.1634 35.9162 31.2503C35.866 31.3372 35.7926 31.4083 35.7041 31.4556C35.6707 31.4676 35.6351 31.4718 35.5998 31.4678C35.5646 31.4638 35.5308 31.4517 35.501 31.4325L23.9737 23.6861L29.3311 19.993C29.3851 19.8747 29.4232 19.7497 29.4442 19.6213C29.3538 19.4678 29.2478 19.3239 29.128 19.192L35.3925 23.4345Z",
    fill: "#F02E25",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0055 15.9877C23.7229 15.9882 23.4461 16.0681 23.2069 16.2185L18.7982 19.2192C18.0526 19.7247 18.7982 20.2279 18.7982 20.2279L23.9755 23.7041L29.1413 20.2279C29.1413 20.2279 29.8869 19.7247 29.1413 19.2192L24.7326 16.2185C24.4924 16.0684 24.2149 15.9885 23.9316 15.9877L24.0032 15.9877",
    fill: "#F02E25"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroneRedMap);
export default __webpack_public_path__ + "static/media/DroneRedMap.74647b06fb2fdd18a878eee42ef6906f.svg";
export { ForwardRef as ReactComponent };